<div class="container d-flex align-items-center flex-column justify-content-center align-middle" id="not-found-component">
    <div>
        <img [src]="notFoundIconPath" id="not-found-img" alt="not found icon">
    </div>
    <div>
        <h1>Page not found</h1>
    </div>
</div>